import { render } from "./WidgetReglement.vue?vue&type=template&id=0d5ee37f&scoped=true&ts=true"
import script from "./WidgetReglement.vue?vue&type=script&lang=ts"
export * from "./WidgetReglement.vue?vue&type=script&lang=ts"

import "./WidgetReglement.vue?vue&type=style&index=0&id=0d5ee37f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5ee37f"]])

export default __exports__